import { Route, Routes } from "react-router-dom";
import AffiliateLanding from "../pages/affiliate/AffiliateLanding";
import Apply from "../pages/affiliate/Apply";
import PageLayout from "../layouts/PageLayout";
import AccountShield from "../components/AccountShield";
import Dashboard from "../pages/affiliate/Dashboard";

export function AffiliateRoutes() {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route index element={<AffiliateLanding />} />
        <Route
          path="apply"
          element={
            <AccountShield>
              <Apply />
            </AccountShield>
          }
        />
        <Route
          path="dashboard"
          element={
            <AccountShield>
              <Dashboard />
            </AccountShield>
          }
        />
      </Route>
    </Routes>
  );
}
